import {
  ConsultantJoinCallListMutationVariables,
  useConsultantJoinCallListMutation
} from "@bonliva-crm/graphql";
import { CallOrContactList, HookProps } from "../utils";

export function useConsultantJoinCallList(props: HookProps) {
  const [consultantJoinCallListMutation] = useConsultantJoinCallListMutation({
    onError: (e) => {
      console.error(e);
      props.onError && props.onError(e);
    },
    onCompleted: (data) => {
      props.onCompleted && props.onCompleted();
    }
  });

  const consultantJoinCallList = (
    args: ConsultantJoinCallListMutationVariables & {
      affectedCallList: CallOrContactList;
    }
  ) => {
    const { affectedCallList, ...rest } = args;
    consultantJoinCallListMutation({
      variables: rest,
      optimisticResponse: (vars) => {
        return {
          addToCallList: {
            __typename: "CallListOpResult",
            callList: {
              ...affectedCallList,
              nodes: [...affectedCallList.nodes, { ...vars.node, __typename: "NodeRef" }]
            }
          }
        };
      }
    });
  };

  return { consultantJoinCallList };
}
